// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretLeftFilledSvg from "@fishx/icons-svg/es/asn/CaretLeftFilled";
import FishxIcon from '../components/FishxIcon';

var CaretLeftFilled = function CaretLeftFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftFilledSvg
  }));
};

CaretLeftFilled.displayName = 'CaretLeftFilled';
export default React.forwardRef(CaretLeftFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretLeftFilled.js
// module id = 2165
// module chunks = 0